(function () {
  'use strict';

  if (customElements.get('crest-cart-formats')) return;

  customElements.define(
    'crest-cart-formats',
    class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected) return;

          const drawer = this.closest('cart-drawer');

          drawer.querySelectorAll(
            '[data-crest-line-editor]'
          ).forEach(editor => {
            if (
              editor.dataset.crestFormatsReady === 'true'
            ) return;

            editor.dataset.crestFormatsReady = 'true';

            const select = editor.querySelector(
              '[data-crest-line-variant]'
            );

            const actions = editor.querySelector(
              '[data-crest-format-actions]'
            );

            const preview = editor.querySelector(
              '[data-crest-format-preview]'
            );

            const group = document.createElement('div');

            group.className = 'crest-format-pills';
            group.setAttribute('role', 'group');
            group.setAttribute(
              'aria-label',
              'Scegli il formato del prodotto'
            );

            const entries = Array.from(
              select.options
            ).map(option => {
              const button =
                document.createElement('button');

              const parts = option.textContent
                .trim()
                .split(' · ');

              button.type = 'button';

              button.textContent = parts[0].replace(
                /(\d)(ml|cl|l)\b/gi,
                '$1 $2'
              );

              button.disabled = option.disabled;
              button.title = option.textContent.trim();

              button.addEventListener('click', () => {
                if (
                  button.disabled ||
                  select.value === option.value
                ) return;

                select.value = option.value;

                select.dispatchEvent(
                  new Event('change', {
                    bubbles: true
                  })
                );
              });

              group.append(button);

              return { button, option };
            });

            function paint() {
              const same =
                select.value === editor.dataset.original;

              entries.forEach(({ button, option }) => {
                button.setAttribute(
                  'aria-pressed',
                  String(option.value === select.value)
                );
              });

              actions.hidden = same;

              const selected = select.selectedOptions[0];

              preview.textContent = selected
                ? selected.textContent.trim()
                : '';
            }

            select.before(group);
            select.hidden = true;
            select.addEventListener('change', paint);

            paint();
          });
        });
      }
    }
  );
})();